import actions from '@/store/modules/admin/actions.js'
import getters from '@/store/modules/admin/getters.js'
import mutations from '@/store/modules/admin/mutations.js'
import getDefaultState from '@/store/modules/admin/state.js'

export default {
  actions,
  getters,
  mutations,
  state: getDefaultState()
}
